export default __webpack_public_path__ + "static/media/img_step_hami01.e3d27a1b.png";